import * as types from './actionTypes';  
import prospectusApi from '../api/prospectusApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function getProspectus(data) {
  return {
    type: types.DO_PROSPECTUS, 
    data
  };
}

export function doProspectusRes(data) {
  return {
    type: types.DO_PROSPECTUS_RES, 
    data
  };
}

export function get_prospectus(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      prospectusApi.getProspectus(data).then(data => {
        dispatch(doProspectusRes(data));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}
